import { lazy } from "react";
// project imports
import MainLayout from "layout/MainLayout";
import Loadable from "ui-component/Loadable";
import ProtectedRoute from "./ProtectedRoute";

import PropertyDetails from "views/utilities/properties/property-detail";
import UserDetails from "views/utilities/users/user-detail";
import UserEnquiryTable from "views/utilities/userEnquiry";
import BadgeSystemOverview from "views/utilities/badgeSystemOverview";
import CouponsDiscount from "views/utilities/couponDiscount";
// dashboard routing
const AdminDashboard = Loadable(
  lazy(() => import("views/admin-dashboard/Default/index"))
);
const Dashboard = Loadable(lazy(() => import("views/dashboard/Default/index")));

const Users = Loadable(lazy(() => import("views/utilities/users/index")));
const UserTime = Loadable(
  lazy(() => import("views/utilities/users/user-time.js"))
);
// section route
const Properties = Loadable(lazy(() => import("views/utilities/properties/index")));

const Reports = Loadable(lazy(() => import("views/utilities/report/index")));

const UserFeatureAccess = Loadable(lazy(() => import("views/utilities/userFeatureAccess/index")));


// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  element: <MainLayout />,



  children: [
    // ================= PROTECTED ROUTES ==================
    {
      element: <ProtectedRoute allowedRoles={["user", "admin"]} />,
      children: [
        {
          path: "dashboard",
          element: <Dashboard />,
        },
        {
          path: "admin-dashboard",
          element: <AdminDashboard />,
        },

        // User routes
        {
          path: "user-list",
          element: <Users />,
        },
        {
          path: "dashboard/user/:id",
          element: <UserDetails />,
        },
        {
          path: "user-time",
          element: <UserTime />,
        },

        // Properties routes
        {
          path: "property-list",
          element: <Properties />,
        },
        {
          path: "dashboard/property/:id",
          element: <PropertyDetails />,
        },
       

        // Reports
        {
          path: "report-list",
          element: <Reports />,
        },

        {
          path: "user-feature-access",
          element: <UserFeatureAccess />,
        },

        {
          path: "user-enquiry",
          element: <UserEnquiryTable />,
        },

        {
          path: "badge-system-overview",
          element: <BadgeSystemOverview />,
        },

         {
          path: "coupons-discount",
          element: <CouponsDiscount/>,
        },
      ]
    },

    // ================= PUBLIC ROUTES ==================
    // (Login, Register etc should be here)
  ],
};


export default MainRoutes;
